import { tickerItems } from "@/mocks/melonData";

function Row({ hidden = false }: { hidden?: boolean }) {
  return (
    <div aria-hidden={hidden || undefined} className="flex shrink-0 items-center gap-10 pr-10">
      {tickerItems.map((t) => (
        <span key={t} className="flex items-center gap-2 whitespace-nowrap text-sm text-background-50">
          <i className="ri-flashlight-fill text-secondary-300" />
          {t}
        </span>
      ))}
    </div>
  );
}

export default function Ticker() {
  return (
    <div className="relative overflow-hidden bg-foreground-950 py-3">
      <div className="flex w-max animate-ticker">
        <Row />
        <Row hidden />
      </div>
    </div>
  );
}